import { Tooltip } from "react-bootstrap";

const GETooltip = ({ msg }) => <Tooltip>{msg}</Tooltip>;

export default GETooltip;
